var map = {
	"./Search.png": 6676,
	"./Shopping cart.png": 876,
	"./Social media.png": 3709,
	"./User.png": 3673,
	"./font/NotoSansSC-Medium.ttf": 642,
	"./font/NotoSansSC-Regular.ttf": 7121,
	"./icon/demo.css": 6630,
	"./icon/iconfont": 7267,
	"./icon/iconfont.css": 7939,
	"./icon/iconfont.js": 7267,
	"./icon/iconfont.json": 6549,
	"./icon/iconfont.ttf": 5039,
	"./icon/iconfont.woff": 653,
	"./icon/iconfont.woff2": 6405,
	"./logo-bottom.png": 3649,
	"./logo.png": 3153,
	"./pic1.png": 7869,
	"./pic2.png": 6662,
	"./pic3.png": 8207,
	"./pic4.png": 2832,
	"./pic5.png": 9081,
	"./submit_icon.png": 6462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;